import React, { useState } from 'react';

export default function SiteMapViewer({ 
  pdfUrl = "/_assets/campen-camping-wayfinding-revideret-20-08.pdf",
  imageUrl = "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/image_5bc12e69.png",
  className = ""
}) {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={`relative rounded-2xl overflow-hidden shadow-md border border-stone-200/50 bg-[#14171a] flex items-center justify-center ${className}`}>
      {!loaded && (
        <div className="absolute inset-0 flex flex-col items-center justify-center bg-stone-900/60 text-white z-10 backdrop-blur-xs">
          <i className="fa-solid fa-spinner fa-spin text-2xl mb-2 text-[#67aedd]" />
          <span className="text-xs font-medium tracking-wide">Henter oversigtskort...</span>
        </div>
      )}

      <a 
        href={imageUrl || pdfUrl} 
        target="_blank" 
        rel="noreferrer"
        className="w-full block cursor-zoom-in group"
        title="Klik for at åbne kort i fuld skærm"
      >
        <img
          src={imageUrl}
          alt="Campen Camping oversigtskort og pladsplacering"
          className={`w-full h-auto block group-hover:opacity-95 transition-all duration-300 ${loaded ? 'opacity-100' : 'opacity-0'}`}
          onLoad={() => setLoaded(true)}
          loading="lazy"
        />
      </a>

      {/* Floating Info & Action Overlay */}
      <div className="absolute bottom-4 left-4 right-4 bg-white/95 backdrop-blur-sm text-stone-800 p-3.5 sm:p-4 rounded-xl text-xs flex flex-col sm:flex-row sm:items-center justify-between gap-2 shadow-md border border-stone-100 z-20">
        <span className="font-medium flex items-center">
          <i className="fa-solid fa-map-location-dot mr-2 text-[#67aedd] text-sm" /> 
          Oversigtskort over hytter og pladser
        </span>
        <div className="flex items-center gap-3">
          <a
            href={imageUrl || pdfUrl}
            target="_blank"
            rel="noreferrer"
            className="text-[#67aedd] hover:text-[#5aa1cc] font-bold inline-flex items-center gap-1.5 hover:underline"
          >
            <i className="fa-solid fa-arrow-up-right-from-square" /> Åbn i fuld skærm
          </a>
        </div>
      </div>
    </div>
  );
}
